import React from "react";
import "./Icons.scss";

const Reset = () => {
  return (
    <svg
      className="icon-reset"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.37 29.62"
    >
      <g>
        <circle className="cls-1" cx="14.36" cy="14.58" r="11.95" />
        <path
          className="cls-2"
          d="M20.18,12.47h-.05l-1.22-.26a.23.23,0,0,1-.18-.26,8.27,8.27,0,0,1,1.77-1.09.21.21,0,0,1,.17.26l-.23,1.14A.27.27,0,0,1,20.18,12.47Zm0-.44Z"
        />
        <path
          className="cls-2"
          d="M8.37,14.75a.23.23,0,0,1-.23-.23,6.32,6.32,0,0,1,12.14-2.46.23.23,0,1,1-.42.18A5.86,5.86,0,0,0,8.59,14.52.23.23,0,0,1,8.37,14.75Z"
        />
        <path
          className="cls-2"
          d="M8.49,18.26H8.44A.24.24,0,0,1,8.27,18l.25-1.19a.26.26,0,0,1,.31-.21l1.25.26a.24.24,0,0,1,.17.27A10.59,10.59,0,0,1,8.49,18.26ZM8.74,17Z"
        />
        <path
          className="cls-2"
          d="M14.55,20.89A6.3,6.3,0,0,1,8.73,17a.23.23,0,0,1,.12-.29.22.22,0,0,1,.3.12,5.87,5.87,0,0,0,11.27-2.28.23.23,0,1,1,.45,0A6.32,6.32,0,0,1,14.55,20.89Z"
        />
      </g>
    </svg>
  );
};

export default Reset;
